import createStore from "@/utils/create-store";
import Model from "@/models/admin/tree-nursings";

export default createStore({ Model });
